module.exports = __webpack_public_path__ + "img/lock.c0323edb.jpg";